export const environment = {
    production: false,
    API_BASE: 'https://api.dev.pl.savinda.lk',
    // API_BASE: 'http://localhost:3000',
    PORTAL: 'https://dev.portal.savinda.lk',
    // API_BASE: 'http://localhost:3000',
    INK_KITCHEN_API_BASE: 'https://api.dev.pl.savinda.lk/ink-kitchen',
    cache: {
        maxSize: 5000,
        maxAge: '1d'
    },
}


